define([
    'backbone',
    'legacy/modules/common/models/enumitem'
], (Backbone, EnumItem) => {

    const Enum = Backbone.Collection.extend({

        model: EnumItem,

        initialize (models, options) {
            this.enumUrl = options.url;
        },

        clone () {
            return new this.constructor(this.models, {url: this.enumUrl});
        },

        url () {

            // TODO: move to base collection
            return `/api/repos/${this.enumUrl}`;
        }

    });

    const TestEnum = Enum.extend({
        fetch () {
            return Promise.resolve(this.models);
        }
    });

    Enum.of = function (url, items) {

        // items can be specified only in DEVELOPMENT environment to develop logic without backend
        // eslint-disable-next-line no-undef
        const debug = DEBUG;
        if (debug && items) {
            return new TestEnum(items, {url});
        }
        if (items) {
            throw Error('`items` can be specified only in DEVELOPMENT environment');
        }
        return new Enum([], {url});
    };

    return Enum;
});
